import React from 'react';
import styles from './SLAPanel.module.css';

interface SLAPanelProps {
  met: number;
  metCount: number;
  missedCount: number;
}

export const SLAPanel: React.FC<SLAPanelProps> = ({ met, metCount, missedCount }) => {
  const circumference = 2 * Math.PI * 45; // radius = 45
  const offset = circumference - (met / 100) * circumference;

  return (
    <div className={styles.slaPanel}>
      <h3 className={styles.title}>SLA</h3>
      <div className={styles.content}>
        <div className={styles.chartContainer}>
          <svg className={styles.donutChart} viewBox="0 0 100 100">
            <circle
              className={styles.donutBackground}
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke="#e9ecef"
              strokeWidth="8"
            />
            <circle
              className={styles.donutForeground}
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke="#28a745"
              strokeWidth="8"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              transform="rotate(-90 50 50)"
            />
          </svg>
          <div className={styles.chartCenter}>
            <div className={styles.label}>SLA met</div>
            <div className={styles.percentage}>{met}%</div>
          </div>
        </div>
        <div className={styles.stats}>
          <div className={styles.statItem}>
            <span className={styles.statValue}>{missedCount.toLocaleString()}</span>
            <div className={styles.statLabelGroup}>
              <span className={styles.statDot} style={{ backgroundColor: '#e21d3c' }}></span>
              <span className={styles.statLabel}>SLA missed</span>
            </div>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statValue}>{metCount.toLocaleString()}</span>
            <div className={styles.statLabelGroup}>
              <span className={styles.statDot} style={{ backgroundColor: '#28a745' }}></span>
              <span className={styles.statLabel}>SLA met</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

